import React from 'react';
import { HStack, Icon, Text } from '@gluestack-ui/themed';
import { CalendarX } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import { formatEnglishDateLong, formatEnglishTime } from '@/common/utils/formatEnglishDateTime';

/**
 * Quiet line above the session list when the student's registration for an
 * upcoming oral exam session was cancelled, so the list does not look like a
 * fresh start.
 */
export function OralExamRegistrationCancelled({ startIso }: { startIso: string }) {
  const { t } = useTranslation();
  const date = `${formatEnglishDateLong(startIso)}, ${formatEnglishTime(startIso)}`;

  return (
    <HStack space="sm" alignItems="flex-start" testID="oral-exam-registration-cancelled">
      <Icon as={CalendarX} size="md" color="$textSubtle" mt="$0.5" />
      <Text flex={1} size="sm" color="$textBody">
        {t('oralExam.registration.cancelled', { date })}
      </Text>
    </HStack>
  );
}
